import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StartUpService } from '../start-up-service/start-up.service';

@Injectable({
    providedIn: 'root'
})
export class AnonGuard {

    constructor(private startupService: StartUpService, private router: Router) {
    }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.startupService.isUserLoggedIn().then((isLoggedIn) => {
            if (!isLoggedIn) {
                this.router.navigateByUrl('/marktplatz');
                return false;
            }
            return true;
        });
    }
}
